import React, { Fragment, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { translate } from '../../../../Services/translation';
import { get } from '../../../../Services/http';
import LensSpecification from '../../../../Components/ProductPage/LensSpecificationSelection';
import { boldSubstr } from '../../../../Components/QuickSearchResult';

const Subscription = forwardRef((props, _ref) => {
    const [productNamesAndPackages, setproductNamesAndPackages] = useState([]);    
    const [filteredProductNamesAndPackages, setfilteredProductNamesAndPackages] = useState([]);
    const [selectedProduct, setselectedProduct] = useState('');
    const [selectedProductName, setselectedProductName] = useState('');
    const [packageSizes, setpackageSizes] = useState([]);
    const [selectedVariantArticleNumber, setselectedVariantArticleNumber] = useState('');
    const [searchTerm, setsearchTerm] = useState('');
    const [showResults, setshowResults] = useState(false);
    const [noresults, setnoresults] = useState(false);
    const [packets, setpackets] = useState([]);
    const lenSpecificationRef = useRef(null);   
    const [lensDurationCategory, setlensDurationCategory] = useState('');
    const [selectedVariantPrice, setselectedVariantPrice] = useState(0);
    const [isSixMonthsDeliverySubscription, setIsSixMonthsDeliverySubscription] = useState(false);
    const [packet, setpacket] = useState(1);

    useEffect(() => {        
            get(`/api/product/getproductnamesandpackage/true`)
            .then((response) => response.json())
            .then((result) => {                
                setproductNamesAndPackages(result);     
                setfilteredProductNamesAndPackages(result);

                if (props.subscriptionToEdit) {
                    const subscriptionInfoForEdit = props.subscriptionToEdit;
                    const product = result.filter(a => a.productArticleNumber === subscriptionInfoForEdit.baseProductArticleNumber)[0];
                    setselectedProduct(product?.productArticleNumber);
                    setselectedProductName(product?.productName);
                    setselectedVariantArticleNumber(subscriptionInfoForEdit.articleNumber);  
                    var productElem =  document.getElementById('productContainer');
                    productElem.scrollIntoView();                  
                }
            });                          
    }, []);

    useEffect(() => {
        const product = productNamesAndPackages.filter(x => x.productArticleNumber === selectedProduct);
        if (product && product.length > 0) {
            setpackageSizes(product[0].variantsWithPackageSize);
            setselectedVariantArticleNumber(product[0].variantsWithPackageSize[0].articleNumber);
        }
        props.onResults();
    }, [selectedProduct]);

    useEffect(() => {
        const product = productNamesAndPackages.filter(x => x.productArticleNumber === selectedProduct);
        if (product && product.length > 0) {
            const variant = product[0].variantsWithPackageSize.filter(a => a.articleNumber === selectedVariantArticleNumber);
            if (variant && variant.length > 0) {
                setpackets(variant[0].packets);
                setlensDurationCategory(variant[0].lensDurationCategory);                
                props.setPrice(props.hideLeftEye ? true : false, variant[0].price);
                props.setNumberOfPackets(props.hideLeftEye ? true : false, packet);
                props.setIsSixMonthsDeliverySubscription(props.hideLeftEye ? true : false, variant[0].isSixMonthsDeliverySubscription);
                setIsSixMonthsDeliverySubscription(variant[0].isSixMonthsDeliverySubscription);
            }
        }
    }, [selectedVariantArticleNumber, packet]);

    const numberOfPacketsChanged = (packet) => {
        setpacket(packet);
    }

    const filterProducts = (text) => {
        setsearchTerm(text);
        const filterData = productNamesAndPackages.filter(x => x.productName.toLowerCase().indexOf(text.toLowerCase()) > -1);
        if (filterData.length > 0) {
            setfilteredProductNamesAndPackages(filterData);
            setnoresults(false);
        }  else {
            setnoresults(true);
        }       
    }    

    const toggleShowProductList = () => {
        setshowResults(!showResults);
        setsearchTerm("");
        setfilteredProductNamesAndPackages(productNamesAndPackages);  
        setnoresults(false);
    };
    
    useImperativeHandle(_ref, () => ({
        getLensSpecificationSelectedValues : () => {                 
            return lenSpecificationRef?.current?.getLensSpecificationSelectedValues();
        },
        getProductAndVariant: () => {
            return {selectedProduct, selectedVariantArticleNumber};
        }
    }))

    return(<Fragment>
        <div className='add-recommendation'>
            <div className='select-product'>                               
                <div id="productContainer" className="columns small-12 mydetails-panel__column">                
                    <label className="form__label">{translate('coptikk.adminportal.customer.productname.header')}</label>                  
                        <div id="mydetails-stores" className={`mydetails-panel__store-name`} onClick={() => toggleShowProductList()}>
                            <div onClick={() => toggleShowProductList()}>{selectedProductName}
                            <span></span>
                            </div>  
                        </div>                                        
                    {showResults && 
                    <div className="mydetails-panel__results">
                        <input className="mydetails-panel__search" onChange={e => filterProducts(e.target.value)} 
                        placeholder={translate('coptikk.adminportal.customer.product.searchplaceholder')} value={searchTerm}></input>
                        <i className="mydetails-panel__search-icon"></i>
                        {noresults && <div>{translate('coptikk.mypages.searchnoresults')}</div>}
                        {!noresults && filteredProductNamesAndPackages.map(x => {
                            return <div className="mydetails-panel__results-item"  onClick={() =>  {
                                setselectedProduct(x.productArticleNumber);
                                setselectedProductName(x.productName);
                                setshowResults(false);                           
                                setsearchTerm("");
                                setfilteredProductNamesAndPackages(productNamesAndPackages);                                
                            }}>
                                <div dangerouslySetInnerHTML={{ __html: searchTerm ? boldSubstr(x.productName, searchTerm) : x.productName}}></div>                                
                                </div>
                        })}                        
                    </div>}   
                </div> 
                <a className="columns subscription__remove-eye-button" onClick={() => { 
                    setselectedProduct("");
                    setselectedProductName("");
                    setsearchTerm("");
                    setselectedVariantArticleNumber("");
                    
                    if (props.hideLeftEye && !props.hideRightEye) {
                        props.resetRightEyePrice();
                    } else if (!props.hideLeftEye && props.hideRightEye) {
                        props.resetLeftEyePrice();
                    }

                    }}>{translate('coptikk.subscription.remove.eye')}</a>     
            </div>
            {selectedProduct && <div className='columns small-12 mydetails-panel__column package'>
                <div>{translate('coptikk.general.packagesizes')}</div>
                <select onChange={(e) => setselectedVariantArticleNumber(e.target.value)} value={selectedVariantArticleNumber}>
                    <option key="" value=""></option>
                    {packageSizes && packageSizes.map(item => {
                        return item && item.packageSize && <option key={item.articleNumber} value={item.articleNumber}>{item.packageSize}</option>
                    })}
                </select>
            </div>} 
            {selectedVariantArticleNumber && <LensSpecification
            currentVariantId={selectedVariantArticleNumber}
            numberOfPackets={packets}
            basePrice={0}
            label={''}
            articleNumber={selectedVariantArticleNumber}
            quantityFieldId={''}
            href={''}
            cssClass={''}
            notAvailable={false}
            isAddingRecommendations={true}
            key={selectedVariantArticleNumber}
            ref={lenSpecificationRef}
            loadFromState={false}
            hideRightEye={props.hideRightEye}
            hideLeftEye={props.hideLeftEye}
            subscriptionToEdit={props.subscriptionToEdit}   
            lensDurationCategory={lensDurationCategory}    
            subscriptionSelected={true}     
            availableForSubscription={true}
            isSixMonthsDeliverySubscription={isSixMonthsDeliverySubscription}
            onNumberOfPacketsChange={numberOfPacketsChanged}
            ></LensSpecification>}
        </div>        
    </Fragment>)
})

export default Subscription;